import { Granularity as LegacyGranularity } from '../../../../common/date-manager/date-manager-constants';
import { TimeSliderConfig } from '../../../../common/filter/filter-store';
import {
  Granularity as V2Granularity,
  Months as V2Months,
  TimeSliderState,
} from '../../../../common/v2/common/components/timeslider/types';
import { getMomentDate } from '../../../../common/v2/date/date-utils';
/**
 * Builds a minimal time context from the PBS time slider config for use with
 * employeeService.list(). Passing this ensures the employee query filters by
 * VERSION_ID / term date so the backend returns point-in-time attributes
 * (e.g. name, job title) instead of nulls.
 */
export function timeContextForEmployeeList(config: TimeSliderConfig): {
  timeSliderState: TimeSliderState;
  firstMonthOfYear: V2Months;
} | null {
  if (!config.startDate || !config.endDate) return null;
  const start = getMomentDate(config.startDate).toDate();
  const end = getMomentDate(config.endDate).toDate();
  const firstMonthOfYear = config.firstMonthOfYear as unknown as V2Months;
  const granularity = config.granularity;

  if (granularity === LegacyGranularity.MONTH) {
    const timeSliderState = {
      start,
      end,
      selectedGranularity: {
        id: 'byMonth',
        label: 'byMonth',
        value: V2Granularity.MONTH,
      },
    } as TimeSliderState;
    return { timeSliderState, firstMonthOfYear };
  }
  if (granularity === LegacyGranularity.YEAR) {
    const timeSliderState = {
      start: getMomentDate(config.startDate).year(),
      end: getMomentDate(config.endDate).year(),
      selectedGranularity: {
        id: 'byYear',
        label: 'byYear',
        value: V2Granularity.YEAR,
      },
    } as TimeSliderState;
    return { timeSliderState, firstMonthOfYear };
  }
  if (granularity === LegacyGranularity.FINYEAR) {
    const timeSliderState = {
      start: getMomentDate(config.startDate).year(),
      end: getMomentDate(config.endDate).year(),
      selectedGranularity: {
        id: 'byFinYear',
        label: 'byFinYear',
        value: V2Granularity.FINYEAR,
      },
    } as TimeSliderState;
    return { timeSliderState, firstMonthOfYear };
  }
  if (granularity === LegacyGranularity.FINQUARTER) {
    const startM = getMomentDate(config.startDate);
    const endM = getMomentDate(config.endDate);
    const timeSliderState = {
      start: { year: startM.year(), quarterOfYear: startM.quarter() },
      end: { year: endM.year(), quarterOfYear: endM.quarter() },
      selectedGranularity: {
        id: 'byFinQtr',
        label: 'byFinQtr',
        value: V2Granularity.FINQUARTER,
      },
    } as TimeSliderState;
    return { timeSliderState, firstMonthOfYear };
  }
  if (granularity === LegacyGranularity.QUARTER) {
    // The v2 employee service does not have a native QUARTER granularity; fall
    // back to MONTH so the VERSION_ID / term-date filter still resolves
    // point-in-time attributes correctly at the end of the period.
    return {
      timeSliderState: {
        start,
        end,
        selectedGranularity: {
          id: 'byMonth',
          label: 'byMonth',
          value: V2Granularity.MONTH,
        },
      } as TimeSliderState,
      firstMonthOfYear,
    };
  }
  // Default fallback for any unrecognised granularity (e.g. DAY, WEEK).
  return {
    timeSliderState: {
      start,
      end,
      selectedGranularity: {
        id: 'byMonth',
        label: 'byMonth',
        value: V2Granularity.MONTH,
      },
    } as TimeSliderState,
    firstMonthOfYear,
  };
}
